import React, { useContext } from 'react';
import { FormikContext } from 'formik';

import { Grid } from '@mui/material';
import type { GridProps } from '@mui/material';

import { isFieldVisible } from '../../../utils';
import type { Field } from '../../../types';

import type { InputFieldFactoryProps } from './InputFieldFactory';
import InputFieldFactory from './InputFieldFactory';

export type FieldGridItemProps = Omit<InputFieldFactoryProps, 'field'> & {
  field: Field;
  gridProps?: Omit<GridProps, 'item' | 'children'>;
};

const FieldGridItem = ({ field, gridProps, ...inputFieldProps }: FieldGridItemProps) => {
  const formik = useContext(FormikContext);
  const formValues = formik?.values ?? {};

  if (!isFieldVisible(field, formValues)) {
    return null;
  }

  return (
    <Grid item {...gridProps}>
      <InputFieldFactory field={field} {...inputFieldProps} />
    </Grid>
  );
};

export default FieldGridItem;
